<template>
  <header class="topbar">
    <div class="crumb">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/></svg>
      <span>{{ crumbRoot }}</span>
      <span class="sep">/</span>
      <b>{{ pageTitle }}</b>
    </div>

    <div class="search">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
      <input :placeholder="t('common.search')" @keyup.enter="go" v-model="q" />
    </div>

    <button class="icon-btn" :title="t('nav.theme')" @click="toggleTheme">
      <svg v-if="isDark" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.2" y1="4.2" x2="5.6" y2="5.6"/><line x1="18.4" y1="18.4" x2="19.8" y2="19.8"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.2" y1="19.8" x2="5.6" y2="18.4"/><line x1="18.4" y1="5.6" x2="19.8" y2="4.2"/></svg>
      <svg v-else width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M21 12.8A9 9 0 1111.2 3 7 7 0 0021 12.8z"/></svg>
    </button>

    <div class="ws">
      <span class="ws-av">{{ initials }}</span>
      <div class="ws-info">
        <div class="ws-name">{{ user?.name }}</div>
        <div class="ws-role">{{ roleLabel }}</div>
      </div>
    </div>
  </header>
</template>

<script>
import { ref, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAuth } from '@/composables/useAuth'
import { useI18n } from '@/composables/useI18n'
import { useTheme } from '@/composables/useTheme'

const TITLES = {
  dashboard: 'nav.dashboard', tasks: 'nav.teamTasks', projects: 'nav.projects',
  team: 'nav.team', archive: 'nav.archive', clients: 'nav.clients', requests: 'nav.requests',
  'c-dashboard': 'portal.navOverview', 'c-projects': 'portal.navProjects', 'c-project': 'portal.navProjects',
  'c-requests': 'portal.navRequests', 'c-reports': 'portal.navReports',
}

export default {
  name: 'AppTopbar',
  setup() {
    const route = useRoute()
    const router = useRouter()
    const { currentUser, isExternalClient, isManager } = useAuth()
    const { t } = useI18n()
    const { toggleTheme, isDark } = useTheme()
    const q = ref('')

    const user = computed(() => currentUser())
    const pageTitle = computed(() => t(TITLES[route.name] || 'nav.dashboard'))
    const crumbRoot = computed(() => isExternalClient() ? 'DevTask' : 'DevTask')
    const roleLabel = computed(() => isExternalClient() ? t('roles.client') : (isManager() ? t('roles.manager') : t('roles.developer')))
    const initials = computed(() => (user.value?.name || '?').split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase())

    function go() {
      if (!q.value.trim() || isExternalClient()) return
      router.push({ name: 'tasks', query: { q: q.value.trim() } })
    }

    return { t, q, user, pageTitle, crumbRoot, roleLabel, initials, toggleTheme, isDark, go }
  },
}
</script>

<style scoped>
.topbar { height: var(--topbar-h, 64px); display: flex; align-items: center; gap: 12px; padding: 0 4px; }
.crumb .sep { color: var(--ink-3); margin: 0 2px; }
.search { max-width: 340px; }
.ws { display: flex; align-items: center; gap: 9px; padding: 4px 6px 4px 4px; border: 1px solid var(--glass-brd); border-radius: 12px; background: var(--glass); }
.ws-av { width: 32px; height: 32px; border-radius: 9px; background: var(--accent); color: var(--on-accent, #fff); display: grid; place-items: center; font-size: 12px; font-weight: 700; }
.ws-name { font-size: 12.5px; font-weight: 700; line-height: 1.1; color: var(--ink); }
.ws-role { font-size: 11px; color: var(--ink-2); margin-top: 1px; }
@media (max-width: 768px) { .topbar { display: none; } }
</style>
